var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0007 4.5835C15.3736 4.5835 5.08398 14.8731 5.08398 27.5002C5.08398 40.1272 15.3736 50.4168 28.0007 50.4168C40.6277 50.4168 50.9173 40.1272 50.9173 27.5002C50.9173 14.8731 40.6277 4.5835 28.0007 4.5835ZM38.9548 22.2293L25.9611 35.2231C25.6402 35.5439 25.2048 35.7272 24.7465 35.7272C24.2882 35.7272 23.8527 35.5439 23.5319 35.2231L17.0465 28.7377C16.3819 28.0731 16.3819 26.9731 17.0465 26.3085C17.7111 25.6439 18.8111 25.6439 19.4757 26.3085L24.7465 31.5793L36.5257 19.8002C37.1902 19.1356 38.2902 19.1356 38.9548 19.8002C39.6194 20.4647 39.6194 21.5418 38.9548 22.2293Z",
    fill: "#2AAE4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickCircle);
export default __webpack_public_path__ + "static/media/green-tick-circle.07a75964af53328a0f2f1e90cff4242c.svg";
export { ForwardRef as ReactComponent };